// extracted by mini-css-extract-plugin
export default {"zoomModal":"TZ-z","image":"UZ-z","button":"VZ-z","isOverlayShown":"WZ-z"};